'use strict';

/* global setTimeout, clearTimeout */
module.exports = function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref$leading = _ref.leading;
  var leading = _ref$leading === undefined ? false : _ref$leading;
  var _ref$accumulate = _ref.accumulate;
  var accumulate = _ref$accumulate === undefined ? false : _ref$accumulate;

  var nextArgs = [];
  var pending = void 0;
  var timer = void 0;
  return function debounced() {
    var nextIdx = nextArgs.length;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    nextArgs[nextIdx] = args;
    var onTimeout = void 0;
    var wasLeading = false;
    if (pending) {
      onTimeout = callOriginal.bind(this, nextArgs, pending);
    } else {
      pending = defer();
      onTimeout = callOriginal.bind(this, nextArgs, pending);
      if (leading) {
        onTimeout();
        nextArgs = [];
        onTimeout = clear;
        wasLeading = true;
      }
    }
    clearTimeout(timer);
    timer = setTimeout(onTimeout, getWait(wait));
    if (accumulate) {
      var _pending = pending;
      if (wasLeading) {
        pending = defer();
      }
      return _pending.promise.then(function (res) {
        return res[nextIdx];
      });
    }
    return pending.promise;
  };

  function callOriginal(args, deferred) {
    var returnValue = accumulate ? fn.call(this, args) : fn.apply(this, args[args.length - 1]);
    returnValue.then(function (v) {
      deferred.resolve(v);
      clear();
    }, function (err) {
      deferred.reject(err);
      clear();
    });
  }

  function clear() {
    nextArgs = [];
    pending = null;
    timer = null;
  }

  function getWait(_wait) {
    if (typeof _wait === 'function') {
      return _wait();
    }
    return _wait;
  }
};

function defer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}
//# sourceMappingURL=index.js.map